import { CollectionsGroupByTable } from "../CollectionsGroupByTable";
import { CollectionsTable } from "../CollectionsTable";
import { Button, DataSource, Label, Layout, LayoutHeader, Panel, Splitter } from "@mcleod/components";

export abstract class AutogenLayoutCollections extends Layout {
    buttonRefresh: Button;
    labelLastRefresh: Label;
    labelLastRefreshDateTime: Label;
    layoutCollectionsTable: CollectionsTable;
    layoutGroupBy: CollectionsGroupByTable;
    layoutheaderCollections: LayoutHeader;
    panelLastRefresh: Panel;
    sourceCollections: DataSource;
    splitterCollections: Splitter;
}
